<template>
  <div id="ShareDraw">
    <transition name="scale">
      <div class="centerPanel ">
        <div class="con">
          <div class="close">
            <img src="./img/close.png"
                 @click="close"/>
          </div>
          <div class="main"
               ref="content">
            <div class="img_area">
              <img :src="base64src" v-if="base64src"
                   class="big_img"
                   alt=" "/>

            </div>
            <div class="code_area flex ac">
              <div class="code_img">
                <canvas class="timeout" id="canvas"></canvas>
              </div>
              <div class="text">
                <p>邀请你一起来使用MJ绘画</p>
                <span>扫码登录立享免费作图</span>
              </div>
            </div>
          </div>
          <div class="down flex jc ac"
               @click="download">
            <img src="./img/icon_img46.png"
                 alt=" "/>
            <p>下载图片</p>
          </div>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
import html2canvas from 'html2canvas';
import QRCode from 'qrcode'

export default {
  props: ['draw_item'],
  data() {
    return {
      base64src: '',
      inviteUrl: ""
    }
  },
  created() {
    this.inviteUrl = MAIN_URLROOT + '/mj/?invite_id=' + this.$store.state.userInfo.uid
    this.getBase64(this.draw_item.raw_img_url).then(base64 => {
      this.base64src = base64
    }, err => {

    })
    this.$nextTick(() => {
      var canvas = document.getElementById('canvas')
      QRCode.toCanvas(canvas, this.inviteUrl, function (error) {
        if (error) console.error(error)
      })
    })
  },
  computed: {},
  methods: {

    //关闭弹窗
    close() {
      this.content = ''
      this.$emit('close', false)
    },
    //提交
    download() {
      const content = this.$refs.content; // 获取需要保存为图片的 DOM 元素
      html2canvas(content).then(canvas => {
        setTimeout(() => {
          // 将 Canvas 转换为图片数据
          const imageData = canvas.toDataURL('image/png');
          // 创建一个 <a> 元素，并设置 href 属性为图片数据
          const a = document.createElement('a');
          a.href = imageData;
          a.download = 'share_image.png'; // 设置下载文件名
          a.click(); // 模拟点击下载

        }, 500)
      },);
    },
    getBase64(img) {
      function getBase64Image(img, width, height) {
        //width、height调用时传入具体像素值，控制大小 ,不传则默认图像大小
        var canvas = document.createElement("canvas");
        canvas.width = width ? width : img.width;
        canvas.height = height ? height : img.height;

        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        var dataURL = canvas.toDataURL();
        return dataURL;
      }

      var image = new Image();
      image.crossOrigin = '';
      image.src = img;
      return new Promise((resolve, reject) => {
        image.onload = function () {
          resolve(getBase64Image(image));//将base64传给done上传处理
        }
      });
    }

  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
#ShareDraw {
  position: fixed;
  z-index: 1501;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transition: all 0.3s;
  background: rgba(0, 0, 0, 0.8);
  overflow: auto;
  animation: fadeInSlowAni 0.3s 1;

  .centerPanel {
    margin: auto;
    border-radius: 2px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
    box-sizing: border-box;
    height: 100%;

    .con {
      width: 420px;
      margin: 0 auto;
      position: relative;
      top: 15vh;

      .close {
        z-index: 9;
        position: absolute;
        right: 15px;
        top: 15px;
        border-radius: 6px;
        box-sizing: border-box;
        width: 26px;
        height: 26px;
        padding: 5px;
        cursor: pointer;
        background-color: #dbdee1;

        img {
          width: 100%;
        }

        &:hover {
          background: #343538;
        }
      }

      .main {
        background: #fff;
        border: 6px solid #726658;
        padding: 14px;

        .img_area {
          position: relative;
          margin-bottom: 10px;

          .big_img {
            width: 100%;
          }
        }

        .code_area {
          padding: 8px;

          .code_img {
            width: 110px;
            height: 110px;
            border: 4px solid #989898;
            border-radius: 5px;
            margin-right: 10px;

            .timeout {
              display: block;
              width: 100% !important;
              height: 100% !important;
            }
          }

          img {
            border: 4px solid #989898;
            border-radius: 4px;
            width: 100px;
            height: 100px;
            margin-right: 20px;
          }

          .text {
            color: #737373;

            p {
              font-size: 20px;
              font-weight: bold;
              margin-bottom: 5px;
            }

            span {
              font-size: 16px;
            }
          }
        }
      }

      .down {
        width: 120px;
        height: 40px;
        border-radius: 20px;
        margin: 20px auto 0;
        background: #000;
        border: 2px solid #726658;
        cursor: pointer;

        img {
          width: 16px;
          margin-right: 10px;
        }

        p {
          font-size: 14px;
          color: #fff;
        }

        &:hover {
          opacity: 0.6;
        }
      }
    }
  }
}

.scale-enter-active,
.scale-leave-active {
  transition: all 0.3s;
}

.scale-enter,
.scale-leave-to {
  transform: translate(-50%, -50%) scale(0.6);
  opacity: 0;
}
</style>